module.exports = __webpack_public_path__ + "static/img/lisa_melissa_famille_homoparentale_canada.32cdc2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lisa_melissa_famille_homoparentale_canada.jpg
// module id = 34
// module chunks = 1